import { Component, OnInit, Input } from '@angular/core';
import { BadgeContent } from '@bluecrew/crew-member-backend-angular-client';

@Component({
  selector: 'app-badge',
  templateUrl: './badge.component.html',
  styleUrls: ['./badge.component.scss'],
})
export class BadgeComponent implements OnInit {

  @Input() content: BadgeContent;

  @Input() useBadgeStyling: boolean = true;

  hideIcon: boolean;
  
  constructor() {}
  
  ngOnInit() {
    this.hideIcon= false;
  }

  getStyle() {
    return new Map(this.content.text.styling?.map(obj => [obj.type, obj.value]));
  }

  setHideIcon(state: boolean) {
    this.hideIcon = state;
  }
}
